<script>
    import { onMount } from 'svelte';
	import { Navigate, navigateTo, Route } from 'svelte-router-spa'
	export let currentRoute;

	let	secondaryColor ='#FFFFFF';
	let	primaryColor = '#000000';
	$: cssVarStyles = `--secondaryColor:${secondaryColor};--primaryColor:${primaryColor}`;
	
	let name = "loading...";
	let dataLoaded = false;
	let business = "loading...";
	let description = "loading...";
	let helpEmail = "";
	let imglink = "";
	let listErrorMessage = '';
	let listPosition = '';
	let listUserName = '';
	let listUserDate = '';
	let listRemoveDate = '';
	let addErrorMessage = '';
	let addPosition = '';
	let prompts = [];
	let listId = currentRoute.queryParams['waitlist'];
	let retryCount = 0;
	let retryMax = 20;
	let loadError = 'Failed to load. Please ensure your waitlist code is correct and try again.';
	let baseUrl = 'https://w8list-pdzc7icgla-uk.a.run.app/api/v1/waitlist';
	//let baseUrl = 'https://localhost:7175/api/v1/waitlist';
	

	async function getData(){
		try{
		const resp = await fetch(`${baseUrl}/${listId}`,
		{
			method: 'GET'
		});
		let dataResponse = await resp.json();
		name = dataResponse.name;
		business = dataResponse.businessName;
		description = dataResponse.description;
		prompts = dataResponse.prompts;
		imglink = dataResponse.imglink;
		helpEmail = dataResponse.helpEmail;
		primaryColor = dataResponse.primaryColor;
		secondaryColor = dataResponse.secondaryColor;

		dataLoaded = true;
		}catch(err){
			retryCount++;
			console.log(err);
		}
	}

	async function CheckLoaded(){
		if(!dataLoaded && retryCount < retryMax){
			setTimeout(async function() {   
				await getData();
				await CheckLoaded();             
			}, 1000);
		}
	}

	async function submitInput(e)
	{
		document.getElementById('addSubmit').disabled = true;
		setTimeout(function() {document.getElementById('addSubmit').disabled = false}, 5000);
		const formdata = new FormData(e.target);
		const json = Object.fromEntries(formdata.entries());
		const data = {};
		for (let field of formdata) {
			const [key, value] = field;
			data[key] = value;
		}
		
		const url = `${baseUrl}/addUser?waitlist=${listId}`;
		const resp = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(json),
				headers: {
					"accept":"*/*",
					"content-type":"application/json"
				}
			});
			let dataResponse = await resp.json()
			addPosition = dataResponse.index;
			addErrorMessage = dataResponse.error;	
	}

	async function checkEmail(e)
	{
		document.getElementById('listSubmit').disabled = true;
		setTimeout(function() {document.getElementById('listSubmit').disabled = false}, 5000);
		const formdata = new FormData(e.target);
		const data = {};
		for (let field of formdata) {
			const [key, value] = field;
			data[key] = value;
		}
		if(data.emailInput != ''){
			const resp = await fetch(`${baseUrl}/position/${listId}?email=${data.emailInput}`,
			{
				method: 'GET',
				headers: {
					"accept":"*/*"
				}
			}
			);
			let dataResponse = await resp.json()
			listPosition = dataResponse.index;
			listUserDate = dataResponse.date;
			listUserName = dataResponse.name;
			listRemoveDate = dataResponse.listRemoveDate;
			listErrorMessage = dataResponse.error;
			
		}
		else
		{
			listPosition = -1;
			listErrorMessage = 'Email Address Required';
		}
	}
	
	onMount(async () => {
		await getData();
		await CheckLoaded();
	});
</script>

<svelte:head>
	<meta name="description" content="A fast and simple waitlist that allows users to check their place in the line.">
	<title>w8list.org is an easy to use waitlist that lets users check their spot in line.</title>
</svelte:head>
<main style="{cssVarStyles}">
	{#if (listId == undefined && retryCount >= retryMax)}
		{navigateTo('login')}
	{:else}
		{#if (!dataLoaded)}
			{#if (retryCount >= (retryMax - 1))}
			<p style="color: red; font-size: 1.3em;">{loadError}</p>
			{:else}
			<h1>Loading...</h1>
			{/if}
		{:else}
			<img src ='{imglink}' alt = "moonlight" id='logoimg'/>
			
			<h1>{name} Waitlist</h1>
			<h2>By {business}</h2>
			<fieldset class= 'formCont'>
				<legend class='legend' align="left">Check your position</legend>
				<form on:submit|preventDefault={checkEmail}>
				<div class = 'label'>Email Address</div>
				
				<div class = 'inputDiv'>
					<input class='input' type = 'text' name="emailInput" id="emailInput"/>
				</div>
				
				<button type='submit' class = 'btn' id='listSubmit'>Submit</button>	
				</form>
			</fieldset>
			{#if (listPosition != '')}
			<div align='center'>
					
				{#if (listPosition < 0)}
				<p class='error'>{listErrorMessage}</p>
				{:else}
				<p class='subRes'>Hi {listUserName}! You are number {listPosition} on the list. You were added to the list on {listUserDate}</p>
				{/if}
			</div>
			{/if}
				<h3>OR</h3>
			<fieldset class= 'formCont'>
				<legend class='legend' align='left'>Get on the list</legend>
				<p style='max-width:240px; text-align:left; margin-top:10px;'>{description}</p>
				<form on:submit|preventDefault={submitInput}>
				{#each prompts as {key, value}}
					
					<div class = 'label'>
						{value} 
					</div> 
					
					<div class = 'inputDiv'>
						<input class='input' type='text' name='{key}' id='{key}' />
					</div>
				{/each}
				<button type='submit' class = 'btn' id='addSubmit'>Submit</button>
				</form>
			
			</fieldset>
			<div align='center'>
				{#if (addPosition != '')}
					{#if (addPosition < 0)}
					<p class='error'>{addErrorMessage}</p>			
					{:else}
					<p class='subRes'>Your request has been submitted. Check your email to see your position. If you do not receive an email confirmation, you may have entered an incorrect email address.</p>
					{/if}
				{/if}
			</div>
			<div style='padding-top: 10px;'>Support at: <a href='mailto: {helpEmail}'>{helpEmail}</a></div>	
		{/if}
	{/if}
	<div class= 'topfooter'></div>
	<div align='center' class='footerContent' >
		<div class='sidebox'></div>
		<div class='box'>

			<div class='footerLines'>W8list support: <a href='mailto: support@w8list.org'>support@w8list.org</a></div>
			<div class='footerLines'>W8list.org ©2024</div>
		</div>
		<div class='sidebox'></div>
	</div>
	<div class= 'footer'></div>
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		color: var(--primaryColor);
		background-color: var(--secondaryColor);
		position: relative;
  		min-height: 100vh;
		
	}
	h1 {
		text-transform: uppercase;
		text-align: center;
		font-size: 3em;
		font-weight: 80;
		margin: 15px;
		}
	h2 {
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 80;
		margin: 15px;
	}
	h3 {
		text-transform: uppercase;
		font-size: 1.5em;
		font-weight: 80;
	}

	.label {
		text-align: left;	
		padding-left: 15px;
		padding-bottom: 5px;
	}

	.inputDiv{
		text-align: center;
	}
	.btn{
		border-radius: 10px;	
	}
	.error{
		color: white;
		background-color: red;
		font-size: 1.3em;
		max-width: 300px;
	}
	.subRes{
		font-size: 1.3em;
		color: var(--primaryColor);
		background-color: var(--secondaryColor);
		max-width: 300px;
	}
	
	.footerContent
	{																									
		position: absolute; 
		bottom: 0%; 
		width: 100%; 
		height: 2.3rem; 
		background-color: rgb(243, 243, 243);
	}

	.footerLines
	{
		color:black;
		width: 48%;
		padding: 1px;
	}
	.legend{
		font-size: 1.3em;
	}
	.topfooter
	{
		min-height: 80px;
	}
	.footer
	{
		min-height: 20px;
	}
	.sidebox {
		float: left;
		width: 29%;
		display:flex;
		padding: 1px;
	}
	.box {
		float: left;
		width: 40%;
		display:flex;
		padding: 1px;
	}
			
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	
		.input{
		border-radius: 10px;
		width:100%;
		}
		.formCont{
			min-width: 280px;
			border-radius: 10px;
			border-width: 1px;
			border-color: var(--primaryColor);
			border-style: solid;
			padding: 15px;
			max-width:fit-content;
			margin-left: auto;
			margin-right: auto;	
		}

	}

	@media (max-width: 639px) {
		main {
			max-width: 450px;
		}
		
		.input{
			border-radius: 10px;
			width:100%;
		}
		.formCont{
			min-width: 280px;
			border-radius: 10px;
			border-width: 1px;
			border-color: var(--primaryColor);
			border-style: solid;
			padding: 15px;
			max-width:fit-content;
			margin-left: auto;
			margin-right: auto;	
		}
		.sidebox {
			width: 1%;
		}
		.box {
			width: 97%;
		}
		.footerContent
		{
			height: 2.8em; 
		}
	}
</style>